<template>
    <zen-message-modal
        :is-open="isOpen"
        title="Revoke token?"
        icon-variant="danger"
    >
        <p>
            <strong>{{ token?.name }}</strong
            >, owned by {{ token?.owner?.name ?? 'this user' }}, will be
            permanently revoked. This cannot be undone.
        </p>
        <template v-slot:buttons>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
            <zen-button
                variant="primary-danger"
                :processing="processing"
                processing-label="Revoking…"
                @click="$emit('confirm')"
            >
                Revoke token
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RevokePersonalAccessTokenModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        token: {
            type: Object,
            default: null,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
